import { jsx as o } from "react/jsx-runtime";
import { useMemo as E } from "react";
import l from "./styles.module.less.js";
import { MobileMenu as N } from "./mobile.js";
import { DesktopMenu as L } from "./desktop.js";
import { DEFAULT_LANGUAGE_CODE as M, canLanguageUseAtticus as _ } from "../../../constants.js";
import { useScreenSize as f, WidthType as g } from "../../../utils/use-is-mobile.js";
const S = "FLOATING_CONTAINER_ID", D = "MENU_HEADER_ID", U = (A) => {
  const {
    isAuthenticated: t,
    openAuthModal: r,
    userImage: n,
    logout: i,
    hasNotifications: s,
    language: e = M,
    getTranslation: a,
    isLawyerSupported: u,
    lmpEnabled: m,
    onRequestLawyer: c,
    hideLinks: p
  } = A, d = E(() => _(e) ? e : void 0, [e]);
  return f() === g.Mobile ? /* @__PURE__ */ o("div", { className: l.mobileMenuWrapper, children: /* @__PURE__ */ o(
    N,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      lmpEnabled: m,
      onRequestLawyer: d ? c : void 0,
      hideLinks: p
    }
  ) }) : /* @__PURE__ */ o("div", { className: l.desktopMenuContainer, id: D, children: /* @__PURE__ */ o(
    L,
    {
      isAuthenticated: t,
      openAuthModal: r,
      userImage: n,
      logout: i,
      hasNotifications: s,
      language: e,
      getTranslation: a,
      isLawyerSupported: u,
      lmpEnabled: m,
      onRequestLawyer: d ? c : void 0,
      hideLinks: p
    }
  ) });
};
export {
  S as FLOATING_CONTAINER_ID,
  D as MENU_HEADER_ID,
  U as MenuComponent
};
